import { Button } from "@msuite/ui/button";
import { useDisclosure } from "@msuite/ui/hooks";
import { Icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { Fragment } from "@msuite/ui/utils";
import type { Substitution } from "@msuite/utils/types";
import { SubstitutionPlanSummaryModal } from "@/modals/users/substitution-plan-summary-modal";

/** Props Interface */
interface ProcessSubstitutionActiveProps {
	substitution: Substitution;
}

export function ProcessSubstitutionActive({ substitution }: ProcessSubstitutionActiveProps) {
	/** Hooks */
	const { t } = useTranslation();
	const disclosure = useDisclosure();

	/** Render */
	return (
		<Fragment>
			<Button
				className="w-[200px] h-stack justify-start"
				onClick={disclosure.onOpen}
				icon={
					<Icon
						name="CheckCheck"
						className="stroke-emerald-500"
					/>
				}
				variant="ghost"
			>
				{t("projects.state.active")}
			</Button>
			{disclosure.isOpen && (
				<SubstitutionPlanSummaryModal
					key={substitution.id}
					isOpen={disclosure.isOpen}
					onClose={disclosure.onClose}
					substitution={substitution}
				/>
			)}
		</Fragment>
	);
}
